export default {
  lineNumberColor: `#657b83`,
  lineNumberBgColor: `#fdf6e3`,
  backgroundColor: `#fdf6e3`,
  textColor: `#657b83`,
  substringColor: `#cb4b16`,
  keywordColor: `#859900`,
  attributeColor: `#b58900`,
  selectorAttributeColor: `#859900`,
  docTagColor: `#2aa198`,
  nameColor: `#268bd2`,
  builtInColor: `#dc322f`,
  literalColor: `#2aa198`,
  bulletColor: `#cb4b16`,
  codeColor: `#657b83`,
  additionColor: `#859900`,
  regexpColor: `#2aa198`,
  symbolColor: `#cb4b16`,
  variableColor: `#b58900`,
  templateVariableColor: `#b58900`,
  linkColor: `#cb4b16`,
  selectorClassColor: `#268bd2`,
  typeColor: `#b58900`,
  stringColor: `#2aa198`,
  selectorIdColor: `#268bd2`,
  quoteColor: `#93a1a1`,
  templateTagColor: `#657b83`,
  deletionColor: `#dc322f`,
  titleColor: `#268bd2`,
  sectionColor: `#268bd2`,
  commentColor: `#93a1a1`,
  metaKeywordColor: `#657b83`,
  metaColor: `#cb4b16`,
  functionColor: `#657b83`,
  numberColor: `#2aa198`,
}
